export enum DenialType {
  SERVICE_AREA = 'SERVICE_AREA',
  INVALID_ADDICTION = 'INVALID_ADDICTION',
}

export default DenialType;
